module.exports = __webpack_public_path__ + "assets/phone-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/phone-icon.png
// module id = 287
// module chunks = 7